import {toast} from 'react-toastify';

export const copyToClipboard = (getValues: (str: string) => string | undefined) => (inputNames: string[]) => {
  navigator.clipboard.writeText(
    inputNames.reduce((prev, cur) => {
      const str = getValues(cur);

      return str ? (prev + ' ' + str).trim() : prev;
    }, ''),
  );

  toast.success('Скопировано', {
    autoClose: 1000,
    hideProgressBar: true,
    pauseOnHover: false,
    draggable: false,
  });
};
